var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 91 91",
    height: "91px",
    id: "Layer_1",
    viewBox: "0 0 91 91",
    width: "91px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M77.377,65.58l1.957-4.213h-55.07c-0.238,0-0.463-0.102-0.623-0.277L6.113,41.539l2.965,9.618    l12.84,14.424H77.377z",
    fill: "#D8C3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.918,65.58L9.078,51.156l4.406,14.287l46.871,21.602c1.553,0.717,3.295,0.779,4.91,0.188    c1.609-0.596,2.887-1.775,3.6-3.32l8.512-18.332H21.918z",
    fill: "#FDF0BC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.637,13.91L4.113,36.802l20.523,22.891l56.012-0.002c1.871,0,3.635-0.734,4.967-2.064   c1.33-1.33,2.064-3.09,2.063-4.957V13.91H24.637z",
    fill: "#F1AFAD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.485,
    cy: 35.99,
    fill: "#FFFFFF",
    r: 15.214
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.242,62.625c-0.596,0-1.162-0.254-1.561-0.697L1.408,38.199c-0.713-0.795-0.713-2,0-2.795      l21.273-23.729c0.398-0.443,0.965-0.697,1.561-0.697h64.252c1.156,0,2.094,0.938,2.094,2.094V52.67      c0.002,2.648-1.035,5.146-2.922,7.029c-1.885,1.885-4.385,2.922-7.039,2.924L24.242,62.625z M5.779,36.802l19.396,21.635      l55.449-0.002c1.537-0.002,2.986-0.604,4.082-1.697c1.092-1.092,1.693-2.537,1.693-4.066V15.166H25.176L5.779,36.802z",
    fill: "#4D7A9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.133,40.271c-1.914,0-3.471-1.557-3.471-3.469c0-1.914,1.557-3.471,3.471-3.471      c1.912,0,3.469,1.557,3.469,3.471C21.602,38.714,20.045,40.271,18.133,40.271z M18.133,36.083c-0.396,0-0.719,0.322-0.719,0.719      c0,0.395,0.322,0.717,0.719,0.717c0.395,0,0.717-0.322,0.717-0.717C18.85,36.406,18.527,36.083,18.133,36.083z",
    fill: "#4D7A9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.779,38.935c-5.346,0-10.277-7.086-12.072-9.664C-0.41,23.359-1.223,9.806,3.734,3.005      C5.682,0.337,7.883,0.728,8.74,1.017c5.238,1.781,8.238,15.521,8.102,20.844c-0.031,1.154-0.988,2.09-2.148,2.039      c-1.156-0.029-2.068-0.99-2.039-2.146C12.803,16.042,9.43,6.044,7.51,5.033C7.428,5.099,7.295,5.23,7.117,5.472      C3.27,10.751,3.881,22.191,7.145,26.878c5.943,8.541,8.764,8.018,9.482,7.656c1.035-0.521,2.293-0.104,2.813,0.928      c0.52,1.033,0.104,2.293-0.93,2.813C17.598,38.734,16.684,38.935,15.779,38.935z",
    fill: "#4D7A9F"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.004,90.568c-1.332,0-2.656-0.289-3.898-0.861L11.895,67.949c-0.539-0.25-0.949-0.717-1.123-1.285      L2.113,38.589c-0.342-1.105,0.277-2.277,1.383-2.617c1.107-0.342,2.277,0.279,2.619,1.383l8.381,27.182l46.363,21.367      c1.248,0.576,2.65,0.629,3.949,0.148c1.293-0.479,2.32-1.424,2.891-2.666l11.027-23.74c0.488-1.049,1.732-1.504,2.781-1.016      c1.049,0.486,1.504,1.73,1.018,2.779L71.502,85.145c-1.035,2.25-2.898,3.971-5.242,4.836      C65.199,90.373,64.1,90.568,63.004,90.568z",
    fill: "#4D7A9F"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M71.471,32.757H39.926c-1.156,0-2.094-0.938-2.094-2.094s0.938-2.094,2.094-2.094h31.545    c1.156,0,2.094,0.938,2.094,2.094S72.627,32.757,71.471,32.757z",
    fill: "#4D7A9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.953,43.621H39.926c-1.156,0-2.094-0.938-2.094-2.094s0.938-2.094,2.094-2.094h17.027    c1.156,0,2.094,0.938,2.094,2.094S58.109,43.621,56.953,43.621z",
    fill: "#4D7A9F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTag);
export default __webpack_public_path__ + "static/media/price-tag.d486bf1599c5e00f41e3709e22d788a3.svg";
export { ForwardRef as ReactComponent };